import { Component, Vue, Watch } from 'vue-property-decorator';
import Router from 'vue-router';
import Home from './views/Home.vue';
import User from "@/module/store/user";

import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';
import {LocalStorage} from "quasar";
import {CONFIG_ENV} from "@/config";

Vue.use(Router);
var  userStore=getModule(User);
const ifNotAuthenticated = (to:any, from:any, next:any) => {
  if (!userStore.user.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const tryToAuthenticate = (to:any, from:any, next:any) => {
//  console.log('%ctryToAuthenticate','color:red;font-size:16px;')
  let isUserAuthenticated = LocalStorage.getItem('isAuthenticated');
  let token_for_permanent_session = LocalStorage.getItem('token_for_permanent_session');
  let userid = LocalStorage.getItem('userid');
  var params = new URLSearchParams();
  params.append('token_for_permanent_session', token_for_permanent_session);
  params.append('userid', userid);
  axios.post(`${CONFIG_ENV.URL_USER.check_token_for_permanent_session}`,params).then((presponse:any)=>{
    if(presponse.data.status=="success"){
      next();
      return;
    }else{
      next('/autentificare');
    }
  });
}

const checkToken = function(to:any, from:any, next:any) {
  axios.get(`${CONFIG_ENV.URL_PRIVATE_INFO.check_token_for_private_list}/${to.params.listid}/${to.params.token_lista}`).then((presponse:any)=>{
    if(presponse.data.status=="success"){
      next();
     // return;
    }else{
     alert(presponse.data.message);
      next('/home');
    }
  });
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/MainPage/MainPage'),
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/new_gifts_list',
      name: 'new_gifts_list',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/NewGiftsList/NewGiftsList'),
      beforeEnter: tryToAuthenticate,
    },
    {
      path: '/user_register',
      name: 'user_register',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/UserRegister/UserRegister'),
    },
    {
      path: '/autentificare',
      name: 'autentificare',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Autentificare/Autentificare'),
    },
    {
      path: '/autentificare_after_validare_email',
      name: 'autentificare_after_validare_email',
      props: {
        prop_after_validare_email: 'yes',
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Autentificare/Autentificare'),
    },
      {
          path: '/bine_ai_venit',
          name: 'bine_ai_venit',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/BineAiVenit/BineAiVenit'),
      },
    {
      path: '/my_home_page',
      name: 'my_home_page',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/MyHomePage/MyHomePage'),
      beforeEnter: tryToAuthenticate,
    },
    {
      path: '/cadouri',
      name: 'cadouri',

      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Cadouri/Cadouri'),
    },
    {
      path: '/donatii',
      name: 'donatii',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Donatii/Donatii'),
    },
    {
      path: '/test',
      name: 'test',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/PageTest.vue'),
    },
    {
      path: '/error_when_check_email/:userid',
      props: true,
      name: 'error_when_check_email',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ErrorWhenCheckEmail.vue'),
    },
    {
      path: '/works_a_list/:m/:listid/:list_name_as_link',
      name: 'works_a_list',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/WorksAList/WorksAList'),
      beforeEnter: tryToAuthenticate,
    },
    {
      path: '/view_public_list/:m/:listid/:token_lista/:list_name_as_link',
      name: 'view_public_list',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ViewOnePublicList/ViewOnePublicList'),
    },
    {
      path: '/view_private_list/:listid/:token_lista/:list_name_as_link',
      name: 'view_private_list',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/ViewOnePrivateList/ViewOnePrivateList'),
      component: () => import(/* webpackChunkName: "about" */ './views/ViewOnePublicList/ViewOnePublicList'),
      //beforeEnter: checkToken,
    },
    {
      path: '/myprofile',
      name: 'myprofile',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/MyProfile/MyProfile.vue'),
      beforeEnter: tryToAuthenticate,
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "about" */ './views/MainPage/MainPage'),
      //component: () => import(/* webpackChunkName: "about" */ './views/PageTest.vue'),

    },
  ],
});
